import Courses from "../../components/Courses";
import { useCourses } from "../../hooks/useCourses";

export interface CoursesScreenProps {
  token: string | null;
  loaderStatus: (status: boolean) => void;
}

/**
 * Business-logic container for the Courses screen. The cascading filters and
 * data loading live in `useCourses`; this wires the state to the presentational
 * `Courses` component.
 */
const CoursesScreen = ({ token, loaderStatus }: CoursesScreenProps) => {
  const state = useCourses(token, loaderStatus);
  return <Courses {...state} />;
};

export default CoursesScreen;
